export const SelectIconStyle = {
  selectedIcon: {
    style: {
      overflow: 'hidden',
      maxHeight: 50,
      fontSize: 12,
    },
  },
  box: {
    style: {
      display: 'flex',
      cursor: 'pointer',
      backgroundColor: 'primary.main',
    },
  },
  icon: {
    style: {
      marginLeft: '10px',
    },
    sx: {
      color: 'text.secondary',
    },
    withArrow: {
      color: 'text.secondary',
      display: 'inline-block',
    },
    hide: {
      display: 'none',
    },
  },

};
